import { Controller } from "@hotwired/stimulus";
import L from "leaflet";

export default class extends Controller {
  static targets = ["map", "latitude", "longitude"];

  connect() {
    this.initMap();
  }

  initMap() {
    // Default to Batam City if no coordinates are set
    let initialLat = 1.082828;
    let initialLng = 104.030453;
    let zoom = 11;

    if (this.latitudeTarget.value && this.longitudeTarget.value) {
      initialLat = parseFloat(this.latitudeTarget.value);
      initialLng = parseFloat(this.longitudeTarget.value);
      zoom = 15;
    }

    this.map = L.map(this.mapTarget).setView([initialLat, initialLng], zoom);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(this.map);

    // Fix default marker icon issues with missing assets in esbuild
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
      iconUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
      shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
    });

    if (this.latitudeTarget.value && this.longitudeTarget.value) {
      this.marker = L.marker([initialLat, initialLng]).addTo(this.map);
    }

    this.map.on("click", this.placeMarker.bind(this));
  }

  placeMarker(e) {
    const lat = e.latlng.lat;
    const lng = e.latlng.lng;

    if (this.marker) {
      this.marker.setLatLng(e.latlng);
    } else {
      this.marker = L.marker(e.latlng).addTo(this.map);
    }

    this.latitudeTarget.value = lat;
    this.longitudeTarget.value = lng;

    this.fetchAddress(lat, lng);
  }

  async fetchAddress(lat, lng) {
    const addressInputId = this.element.dataset.addressInputId || "event_address";
    const addressInput = document.getElementById(addressInputId);
    if (!addressInput) return;

    const originalValue = addressInput.value;
    addressInput.value = "Fetching address...";

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
      );
      const data = await response.json();

      if (data && data.display_name) {
        addressInput.value = data.display_name;
      } else {
        addressInput.value = originalValue;
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      addressInput.value = originalValue;
    }
  }

  disconnect() {
    if (this.map) {
      this.map.remove();
    }
  }

  resize() {
    if (this.map) {
      this.map.invalidateSize();
    }
  }
}
